//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
import CheckboxQueryFilter from './CheckboxQueryFilter';
import DateQueryFilter from './DateQueryFilter';

export default {
    name: "AppQueryPanel",
	components: {
        appCheckboxQueryFilter: CheckboxQueryFilter,
        appDateQueryFilter: DateQueryFilter
	},
	computed: {
        ...mapGetters(['getAvailableFilters'])
    },
    methods: {
        ...mapActions(['clearFilters', 'showFilters'])
    }
};
